import React from "react";

/* THE official Ponesi loader — ported from the approved HTML/CSS source (animation, proportions
   and timing unchanged; brand red adapted to #B61414 and the mark is the current approved Ponesi
   logo asset). Every blocking customer-facing wait renders this component: startup gate, lazy
   route Suspense, restaurant page, order tracking, auth bootstrap.
   `contained` keeps the same design language inside a page section instead of the whole screen.
   No minimum display time: it disappears the moment the caller stops rendering it. */
export default function PonesiLoader({ contained = false, label = "Učitavanje…" }) {
  return (
    <div className={contained ? "ponesi-loader ponesi-loader--contained" : "ponesi-loader"}
      role="status" aria-live="polite" data-testid="ponesi-loader">
      <div className="ponesi-loader__brand">
        <div className="ponesi-loader__lockup">
          <img className="ponesi-loader__mark" src="/brand/ponesi-footer-logo.webp?v=9" alt=""
            aria-hidden="true" decoding="async" fetchPriority="high" />
        </div>
        <div className="ponesi-loader__track" aria-hidden="true" />
        <span className="sr-only">{label}</span>
      </div>
    </div>
  );
}
